import { mapGetters, mapMutations, mapState } from 'vuex'

const mixinsLeasingOffers = {
  methods: {
    ...mapMutations([
      'setField',
      'addRecordToCompare',
      'removeRecordFromCompare',
    ]),
  },
  computed: {
    ...mapGetters([]),
    ...mapState([
      'type',
      'brands',
      'brandsArgs',
      'models',
      'modelsArgs',
      'editions',
      'editionsArgs',
      'fuels',
      'fuelsArgs',
      'bodyTypes',
      'transmissions',
      'prices',
      'deposit',
      'extras',
      'extrasOptionIds',
      'numOfPayments',
      'annualKm',
      'buybackAmount',
      'buyback',

      'rentalPrice',
      'vat',
      'finalPrice',
      'extraPrice',

      'recordsCompare',
    ]),
  },
}

export default mixinsLeasingOffers
